module.exports = __webpack_public_path__ + "media/images/icons/login-facebook-5bf4a40dc99b634322c350907ce3037b.svg";